/**
 * @author  Ikaros Kappler
 * @date    2021-07-00
 * @version 1.0.0
 */
export {};
//# sourceMappingURL=externals.js.map